var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"learn-item",on:{"click":_vm.enterLearnItem}},[_c('div',{staticClass:"learn-item-img"},[_vm._t("learn-item-img"),_c('p',{staticClass:"opacity"})],2),_c('div',{staticClass:"laern-item-text"},[_vm._t("learn-item-text")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }